// extracted by mini-css-extract-plugin
module.exports = {"anchor":"a10a3f92e9--anchor--XqEHi"};